"use client";

import classNames from "@calcom/ui/classNames";
import { useEffect, useRef } from "react";

type Props = {
  botUsername: string;
  callbackUrl?: string;
  className?: string;
};

const TelegramIcon = () => (
  <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M9.78 15.29 9.5 19.7c.39 0 .56-.17.77-.38l1.86-1.78 3.85 2.83c.71.39 1.21.18 1.39-.65l2.53-11.9h.01c.22-1.03-.37-1.43-1.05-1.19L2.3 10.2c-1.01.39-1 .95-.17 1.2l4.86 1.52L18.9 6.5c.61-.41 1.17-.18.71.15"
    />
  </svg>
);

export default function TelegramLoginButton({ botUsername, callbackUrl = "/", className }: Props) {
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host || !botUsername) return;

    host.innerHTML = "";
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.setAttribute("data-telegram-login", botUsername);
    script.setAttribute("data-size", "large");
    const authUrl = new URL("/api/auth/telegram/callback", window.location.origin);
    if (callbackUrl) authUrl.searchParams.set("callbackUrl", callbackUrl);
    script.setAttribute("data-auth-url", authUrl.toString());
    script.setAttribute("data-request-access", "write");
    host.appendChild(script);
  }, [botUsername, callbackUrl]);

  return (
    <div className={classNames("w-full", className)}>
      <div className="mb-2 flex items-center justify-center gap-2 text-sm text-subtle">
        <TelegramIcon />
        <span>Войти через Telegram</span>
      </div>
      <div ref={hostRef} className="flex w-full justify-center [&>iframe]:!w-full" />
    </div>
  );
}
